(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
$(document).on('cc:component:load', function () {
  tryUpdateProductCount();
})

const tryUpdateProductCount = () => {
  var utilityBars = Array.from(document.querySelectorAll('.utility-bar'));
  var numProducts = Array.from(document.querySelectorAll('#content .product-block'));
  var paginationLen = document.querySelector('.container .pagination-row').innerText.length;
  
  var utilityBar = utilityBars.map(x => {
    var target = x.querySelector('.utility-bar__centre .utility-bar__item');
  
    if (target) {
      if (target.innerText.includes('products')) {
        return x;
      }
    }
  }).filter(x => x !== undefined);
  
  if (utilityBar.length) {
    utilityBar = utilityBar[0];

    utilityBarCenter = utilityBar.querySelector('.utility-bar__centre .utility-bar__item');
    const oldCount = utilityBarCenter.innerText.match(/\d+/gi)[0];
    const newCount = numProducts.length;
    var diff;

    if (oldCount < newCount) {
      diff = oldCount - newCount;
    } else {
      diff = newCount - oldCount;
    }

    // this essentially prevents the count from happening if there is more than one page of products. 
    // instead of stopping, let's count the number of products as usual but then add it to the filter count.
    // display as filter count + e.g: "325 products" becomes "336+ products"

    if (paginationLen === 0) {
      utilityBarCenter.innerHTML = `${numProducts.length} products`;
      // console.warn('updating product count', oldCount, newCount, diff);
    }
  }
}

tryUpdateProductCount();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
